/**
 * キーワードの初期値の生成
 * @param keywordList
 * @returns キーワード
 */
export const createInitialSearchText = (keywordList: string[] | undefined) => {
  if (!keywordList) {
    return '';
  }
  if (!keywordList.length) {
    return '';
  }
  if (keywordList.length >= 2) {
    return keywordList?.join(' ');
  }
  return keywordList[0];
};
